import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import { InputCurrency } from '@plato/ui-legacy/components/ui/input-number';
import type { FocusEventHandler, ReactElement } from 'react';

export type UnitPriceInputProps = {
    disabled?: boolean;
    loading?: boolean;
    name?: string;
    onBlur?: FocusEventHandler<HTMLInputElement>;
    onValueChange: (value: number) => void;
    scaleFactor?: number;
    unit?: string;
    value: number;
};

export function UnitPriceInput({
    onValueChange,
    scaleFactor = 1,
    unit = '',
    ...rest
}: UnitPriceInputProps): ReactElement {
    const { defaultCurrency } = useAppConfig();

    let suffix: string;
    if (scaleFactor === 1) {
        if (unit) {
            suffix = ` / ${unit}`;
        } else {
            suffix = '';
        }
    } else {
        suffix = ` / ${scaleFactor}`;
        if (unit) {
            suffix += ` ${unit}`;
        }
    }

    return (
        <InputCurrency
            currency={defaultCurrency}
            {...rest}
            suffix={suffix}
            onValueChange={({ floatValue }) => {
                onValueChange(floatValue ?? 0);
            }}
        />
    );
}
